import React from 'react'
import MainLoader from '../../images/loading2.gif';
const Loader = () => {
  return (
    <div className='bill'>
        <img src={MainLoader} alt="loading" className='loadingImg'/>
    </div>
  )
}

export default Loader